var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgViewReport(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 38,
    height: 38,
    viewBox: "0 0 38 38",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 38,
    height: 38,
    transform: "translate(0 -0.147)",
    fill: "#0087ff"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0.147)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M37.664,7.123,30.724.183A.652.652,0,0,0,30.276,0H14.5a1.9,1.9,0,0,0-1.893,1.893V5.709a13.231,13.231,0,0,0,0,26.434V35.96A1.9,1.9,0,0,0,14.5,37.853h21.45a1.9,1.9,0,0,0,1.893-1.893V7.571a.652.652,0,0,0-.183-.448M30.907,2.151,35.7,6.94H31.538a.631.631,0,0,1-.631-.631ZM1.256,18.926A12,12,0,0,1,12.612,6.959V18.668L4.347,26.932A11.91,11.91,0,0,1,1.256,18.926Zm3.981,8.9L13.5,19.557H25.21A11.963,11.963,0,0,1,5.237,27.822ZM36.585,35.96a.631.631,0,0,1-.631.631H14.5a.631.631,0,0,1-.631-.631V32.143A13.257,13.257,0,0,0,26.491,18.926a.631.631,0,0,0-.631-.631H13.874V1.893a.631.631,0,0,1,.631-.631H29.645V6.309A1.9,1.9,0,0,0,31.538,8.2h5.047Z",
    transform: "translate(0)",
    fill: "#0087ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192.563,40a.631.631,0,0,0-.631.631V53.248a.631.631,0,0,0,.631.631H205.18a.631.631,0,0,0,.631-.631A13.263,13.263,0,0,0,192.563,40m.631,12.618V41.281a12,12,0,0,1,11.337,11.337Z",
    transform: "translate(-176.796 -36.846)",
    fill: "#0087ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M309.61,304a5.678,5.678,0,1,0,5.678,5.678A5.678,5.678,0,0,0,309.61,304m0,10.094a4.416,4.416,0,1,1,4.416-4.416,4.416,4.416,0,0,1-4.416,4.416",
    transform: "translate(-279.964 -280.027)",
    fill: "#0087ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M332.615,349.683l-1.447-1.447-.892.892,1.893,1.893a.631.631,0,0,0,.892,0l3.785-3.785-.892-.892Z",
    transform: "translate(-304.231 -319.031)",
    fill: "#0087ff"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 5.047,
    height: 1.262,
    transform: "translate(30.277 10.725)",
    fill: "#0087ff"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 5.047,
    height: 1.262,
    transform: "translate(30.277 14.51)",
    fill: "#0087ff"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 5.047,
    height: 1.262,
    transform: "translate(30.277 18.295)",
    fill: "#0087ff"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgViewReport);
export default __webpack_public_path__ + "static/media/view_report.97c1b327f2d8f8da3c86c84160596d51.svg";
export { ForwardRef as ReactComponent };